// services/produitService.js
import api from './auth';

export const produitService = {
  // Récupérer tous les produits
  getAllProduits: async (params = {}) => {
    try {
      const response = await api.get('/inventory/produits/', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits:', error);
      throw error;
    }
  },

  // Récupérer un produit par ID
  getProduitById: async (id) => {
    try {
      const response = await api.get(`/inventory/produits/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la récupération du produit ${id}:`, error);
      throw error;
    }
  },

  // Créer un nouveau produit
  createProduit: async (produitData) => {
    try {
      // ✅ SI déjà FormData, envoyer directement
      if (produitData instanceof FormData) {
        const response = await api.post('/inventory/produits/', produitData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        return response.data;
      }
      
      // ✅ SINON (objet JS normal), créer FormData
      const formData = new FormData();
      
      Object.keys(produitData).forEach(key => {
        const value = produitData[key];
        
        if (value !== null && value !== undefined) {
          if (key === 'conditionnements') {
            // Stringifier si object ou array
            if (typeof value === 'object') {
              formData.append(key, JSON.stringify(value));
            } else {
              formData.append(key, value);
            }
          } else if (key === 'image' && value instanceof File) {
            formData.append(key, value);
          } else {
            formData.append(key, value);
          }
        }
      });

      const response = await api.post('/inventory/produits/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ Erreur création produit:', error);
      throw error;
    }
  },

  // Mettre à jour un produit
  updateProduit: async (id, produitData) => {
    try {
      // ✅ SI déjà FormData, envoyer directement
      if (produitData instanceof FormData) {
        const response = await api.patch(`/inventory/produits/${id}/`, produitData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        return response.data;
      }
      
      // ✅ SINON (objet JS normal), créer FormData
      const formData = new FormData();
      
      Object.keys(produitData).forEach(key => {
        const value = produitData[key];
        
        if (value !== null && value !== undefined) {
          if (key === 'conditionnements') {
            // Stringifier si object ou array
            if (typeof value === 'object') {
              formData.append(key, JSON.stringify(value));
            } else {
              formData.append(key, value);
            }
          } else if (key === 'image' && value instanceof File) {
            formData.append(key, value);
          } else {
            formData.append(key, value);
          }
        }
      });

      const response = await api.patch(`/inventory/produits/${id}/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ Erreur mise à jour produit:', error);
      throw error;
    }
  },

  // Supprimer un produit
  deleteProduit: async (id) => {
    try {
      const response = await api.delete(`/inventory/produits/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la suppression du produit ${id}:`, error);
      throw error;
    }
  },

  // Rechercher des produits
  searchProduits: async (searchTerm) => {
    try {
      const response = await api.get('/inventory/produits/', {
        params: { search: searchTerm }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la recherche des produits:', error);
      throw error;
    }
  },

  // Activer/Désactiver un produit
  toggleActivation: async (id, estActif) => {
    try {
      const response = await api.patch(`/inventory/produits/${id}/`, {
        est_actif: estActif
      });
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la modification de l'état du produit ${id}:`, error);
      throw error;
    }
  },

  // Produits en rupture de stock
  getEnRupture: async () => {
    try {
      const response = await api.get('/inventory/produits/en_rupture/');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits en rupture:', error);
      throw error;
    }
  },

  // Produits avec stock faible
  getStockFaible: async () => {
    try {
      const response = await api.get('/inventory/produits/stock_faible/');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits avec stock faible:', error);
      throw error;
    }
  },

  // Historique des mouvements de stock
  getMouvements: async (id) => {
    try {
      const response = await api.get(`/inventory/produits/${id}/mouvements/`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la récupération des mouvements du produit ${id}:`, error);
      throw error;
    }
  },

  // Produits pour vente (pour les vendeurs)
  getPourVente: async (params = {}) => {
    try {
      const response = await api.get('/inventory/produits/pour-vente/', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits pour vente:', error);
      throw error;
    }
  },

  // Ajuster le stock
  ajusterStock: async (id, quantite, typeMouvement, motif) => {
    try {
      const response = await api.post(`/inventory/produits/${id}/ajuster-stock/`, {
        quantite,
        type_mouvement: typeMouvement,
        motif
      });
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de l'ajustement du stock du produit ${id}:`, error);
      throw error;
    }
  },

  // Importer des produits depuis Excel
  importProduits: async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post('/inventory/produits/import/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'import des produits:', error);
      throw error;
    }
  },

  // Exporter les produits
  exportProduits: async (params = {}) => {
    try {
      const response = await api.get('/inventory/produits/export/', {
        params,
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'export des produits:', error);
      throw error;
    }
  },
};

export default produitService;